import { crmRecordPath } from "./crm-navigation.js";
import { projectPath, projectTasksPath } from "./project-navigation.js";

export type InboxNotification = {
  id: string;
  source: "crm" | "projects";
  title: string;
  body: string;
  context: string;
  createdAt: string;
  readAt: string | null;
  activityId: string | null;
  projectId: string | null;
  taskId: string | null;
};

export type NotificationInboxResponse = {
  unreadCount: number;
  limit: number;
  items: InboxNotification[];
};

export function notificationPath(item: InboxNotification): string | null {
  if (item.source === "crm")
    return item.activityId ? crmRecordPath("activities", item.activityId) : null;
  if (!item.projectId) return null;
  return item.taskId
    ? projectTasksPath(item.projectId, { taskId: item.taskId, readOnly: true })
    : projectPath(item.projectId);
}
